<template>
  <div>
    <div class="bi-download-pdf" :class="{ loading: loading }" @click="$emit('click')" v-bt-tooltips :title="t('bi.export_pdf')">
      <template v-if="!loading">
        <download-icon />
      </template>
      <div v-else class="spinner-border-container">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ t('global.loading') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DownloadIcon from '@/assets/icons/modules/analytics/bi/DownloadIcon.vue';
import { useI18n } from 'vue-i18n';

interface Props {
  loading: boolean;
}

const { t } = useI18n();

withDefaults(defineProps<Props>(), {
  loading: false,
});
defineEmits(['click']);
</script>

<style lang="scss">
// TODO: split to .scss file
.bi-download-pdf {
  width: 38px;
  height: 38px;
  border: 1px solid #606a6c;
  border-radius: 10px;
  background-color: white;
  margin: 0 0.5rem;
  display: flex;
  transition: 0.2s all;
  cursor: pointer;

  &.loading {
    pointer-events: none;
    border: 1px solid lightgrey;
    color: lightgrey;
  }

  &:hover {
    box-shadow: 0 2px 10px #e5362372;
    border: 1px solid #e53623;
    background-color: #e53623;

    svg {
      fill: white;
    }
  }

  svg {
    width: 17px;
    height: 16px;
    margin: auto;
    fill: #606a6c;
  }

  .spinner-border-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .spinner-border {
    height: 60%;
    width: 60%;
  }
}
</style>
